import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UserGrid = ({ users, companies, onEdit, onDelete, onToggleStatus }) => {
  const getCompanyName = (companyId) => {
    const company = companies?.find(c => c?.id === companyId);
    return company?.name || 'N/A';
  };

  const getPlantNames = (companyId, plantAccess) => {
    const company = companies?.find(c => c?.id === companyId);
    if (!company || !plantAccess || plantAccess?.length === 0) return 'N/A';
    const plants = company?.plants?.filter(p => plantAccess?.includes(p?.id));
    return plants?.map(p => p?.name)?.join(', ') || 'N/A';
  };

  if (users?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Users" size={48} className="mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No users found</h3>
        <p className="text-muted-foreground">Create your first user to get started</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">User</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Role</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Company</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Plant Access</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Status</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users?.map((user) => (
            <tr
              key={user?.id}
              className="border-b border-border hover:bg-muted/50 transition-colors"
            >
              <td className="py-4 px-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name="User" size={18} className="text-primary" />
                  </div>
                  <div>
                    <p className="font-medium text-foreground">{user?.name}</p>
                    <p className="text-sm text-muted-foreground">{user?.email}</p>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <span
                  className={`inline-flex items-center px-2.5 py-1 rounded-lg text-sm font-medium ${
                    user?.role === 'Admin' ?'bg-accent/10 text-accent' :'bg-success/10 text-success'
                  }`}
                >
                  {user?.role === 'Admin' && <Icon name="Shield" size={14} className="mr-1" />}
                  {user?.role}
                </span>
              </td>
              <td className="py-4 px-4 text-foreground">{getCompanyName(user?.companyId)}</td>
              <td className="py-4 px-4 text-muted-foreground text-sm">
                {user?.role === 'Admin' ? 'All Plants' : getPlantNames(user?.companyId, user?.plantAccess)}
              </td>
              <td className="py-4 px-4">
                <button
                  onClick={() => onToggleStatus(user?.id)}
                  className={`inline-flex items-center px-2.5 py-1 rounded-lg text-sm font-medium transition-colors ${
                    user?.status === 'Active' ?'bg-success/10 text-success hover:bg-success/20' :'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                >
                  <Icon
                    name={user?.status === 'Active' ? 'CheckCircle' : 'XCircle'}
                    size={14}
                    className="mr-1"
                  />
                  {user?.status}
                </button>
              </td>
              <td className="py-4 px-4">
                <div className="flex items-center justify-end gap-2">
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="Edit"
                    onClick={() => onEdit(user)}
                  />
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="Trash2"
                    onClick={() => onDelete(user?.id)}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserGrid;